import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Root } from './Spinner.styles'

/**
 * The Spinner's component.
 */
const Spinner = forwardRef((props, ref) => <Root {...props} ref={ref} />)

Spinner.defaultProps = {
  color: 'primary',
  size: 40
}

Spinner.propTypes = {
  /**
   * Color.
   */
  color: PropTypes.oneOf(['primary', 'white']),
  /**
   * Size.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Spinner
